export const UserActionTypes = {

    FETCH_USERS_REQUEST: "FETCH_USERS_REQUEST",
    FETCH_USERS_FAILED: "FETCH_USERS_FAILED",
    FETCH_USERS_SUCESS: "FETCH_USERS_SUCESS",
    VALID_USER_SUCESS: "VALID_USER_SUCESS",
    VALID_USER_FAILED: "VALID_USER_FAILED",
    EMAIL_Availability_SUCESS: "EMAIL_Availability_SUCESS",
    EMAIL_Availability_FAILURE: "EMAIL_Availability_FAILURE",
    RESET_LOGIN_STATE: "RESET_LOGIN_STATE",
    RESET_SIGNUP_STATE: "RESET_SIGNUP_STATE",
    USER_LOGUT: "USER_LOGUT",
    SET_LOADING: "SET_LOADING",
    GET_USER: "GET_USER",
    SET_USER: "SET_USER",
    UPDATE_USER: "UPDATE_USER",

}